import React from "react";
import { SearchIcon } from "./../icons/SvgIcons";
import { JobSortingEnum } from "../enums/jobSorting.enum";
import { sectionCardCompactClasses } from "../styles/pageClasses";
import { filterBarClasses } from "../styles/componentClasses";

interface FilterBarProps {
    q: string;
    onQ: (v: string) => void;
    sort: JobSortingEnum;
    onSort: (v: JobSortingEnum) => void;
    right?: React.ReactNode;
    className?: string;
}

export function FilterBar({
    q,
    onQ,
    sort,
    onSort,
    right,
    className = "",
}: FilterBarProps) {
    return (
        <div className={`${sectionCardCompactClasses} ${filterBarClasses.wrapper} ${className}`}>
            <div className={filterBarClasses.layout}>
                <div className={filterBarClasses.searchWrap}>
                    <SearchIcon className={filterBarClasses.searchIcon} />
                    <input
                        value={q}
                        onChange={(e) => onQ(e.target.value)}
                        placeholder="Search roles, companies, categories, locations..."
                        inputMode="search"
                        className={filterBarClasses.searchInput}
                    />
                </div>

                <div className={filterBarClasses.controls}>
                    <label htmlFor="sort-select" className={filterBarClasses.label}>
                        Sort
                    </label>

                    <select
                        id="sort-select"
                        value={sort}
                        onChange={(e) => onSort(e.target.value as JobSortingEnum)}
                        className={filterBarClasses.select}
                    >
                        <option value={JobSortingEnum.New}>Newest</option>
                        <option value={JobSortingEnum.Old}>Oldest</option>
                        <option value={JobSortingEnum.SalaryDesc}>Salary: High to Low</option>
                        <option value={JobSortingEnum.SalaryAsc}>Salary: Low to High</option>
                    </select>

                    {right}
                </div>
            </div>
        </div>
    );
}
